/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsCreateVersion } from "../../funcs/llmSkillsCreateVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateSkillVersionRequest$inboundSchema,
};

export const tool$llmSkillsCreateVersion: ToolDefinition<typeof args> = {
  name: "llm-skills-create-version",
  description: `Create skill version

Create a new immutable version of a skill by uploading files. The uploaded files must include a SKILL.md manifest.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsCreateVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
